import initContactForm from '@js/components/feedbackForm';

$(() => {
    initContactForm();
});
